module.exports = __webpack_public_path__ + "img/basic.57379972.svg";